import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormControl, Validators } from '@angular/forms';


import Swal from 'sweetalert2';

import { FirestoreService } from '../services/firebase/firestore.service';
import { AuthService } from '../services/service.index';
import { version } from '../../../package.json'

declare function init_plugins(): any;
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  forma: FormGroup;
  email: string;
  version:any;

  constructor(private auth: AuthService, private router: Router, private afs: FirestoreService) { }

  ngOnInit(){

    this.version = version;

    this.forma = new FormGroup({
      email: new FormControl( null, [Validators.required, Validators.email, Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$")]),
      password: new FormControl( null, Validators.required),
      remember: new FormControl(false)
    });

    this.email = localStorage.getItem('email') || '';
    this.forma.controls['email'].setValue(this.email);
    if(this.email.length > 1){
        this.forma.controls['remember'].setValue(true);
    }


  }


  ngDestroy(){



  }

  ingresar(){


      //console.log(this.forma.value);

        if(this.forma.valid){

        this.auth.signUser(this.forma.value.email, this.forma.value.password, this.forma.value.remember).then( (data:any)=>{


            if(data.user){

              //console.log(data.user);
              //console.log(data.user.uid);

              this.afs.getUserUID(data.user.uid).subscribe((resp) => {

                  //console.log(resp);

                  //localStorage.setItem("user",JSON.stringify(resp[0]));

                  this.router.navigate(['/dashboard']);
              });

              //
            }

        }).catch(err =>{

                        Swal.fire({
                                heightAuto: false,
                                  icon: 'error',
                                  title: 'Oops...',
                                  text: 'Check email and password is wrong!',
                           });
                       });
      }else{


            Swal.fire({
              heightAuto: false,
              icon: 'error',
              title: 'Oops...',
              text: 'Check email and password is wrong!!',
            });


      }

  }

  onGoogle(){

    try{

      this.auth.loginGoogle().then(user => {

        this.afs.getUserUID(user.user.uid).subscribe((resp) => {


          if(resp){
            this.router.navigate(['/dashboard']);
          }else{

            let us:any = {};

            us.email = user.user.email;
            us.id = user.user.uid;
            us.img = user.user.photoURL;
            let name = user.user.displayName.split(" ");
            us.firstname = name[0];
            us.lastname = name[1];
            us.status = true;
            us.phone = user.user.phoneNumber;
            us.role = 1;
            //with default company
            us.companyId = "k8xsussq4RvoSTYRh7PO";

            this.afs.createUserUID(us).then((resp) => {

              this.router.navigate(['/dashboard']);

           }).catch(err => {

              console.log(err);

          })
          }

        });


      }).catch(err => {
          console.log(err);
      });

    }catch(err){
      console.log(err);
    }

  }

}
